import Backbone from 'backbone'
import fontSizeLabel from './font-size-label.hbs'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import _ from 'lodash'

function sizeLabel(size, baseSize) {
	return _.isNil(baseSize) ? size : size - baseSize
}

var FontSizeOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'fontSize'
})

var FontSizeLabelView = Backbone.View.extend({
	className: 'config-font-size',

	baseSize: undefined,

	initialize: function () {
		// #59829 listen for changes to any property, since the label could
		// change based on things like showX properties
		this.listenTo(this.model, 'change', this.render.bind(this))
	},

	_sizeLabel: function () {
		const sizeValue = this.model.get(this.property)
		if (sizeValue) {
			return sizeLabel(sizeValue, this.baseSize)
		} else {
			return ''
		}
	},

	render: function () {
		this.$el.html(fontSizeLabel({
			sizeLabel: this._sizeLabel(),
			label: _.result(this, 'label')
		}))
		return this
	}
})

/**
 * Returns a bootslide menu target with a submenu of font size options.
 *
 * @param model the model to update (usually a widget model's properties model)
 *
 * @param opt.extraLarge {Boolean} adds in "extra large" font size options used in certain widgets
 *
 * @param [opt.baseSize] {Number} if set, display sizes as relative offsets from this font size
 *
 * @param opt.hidden {Boolean} whether the option should be hidden upon render
 *
 * @param [opt.label] {String|Function} the label to display for the menu. If
 * not provided, will use a generic term based on whether baseSize is specified
 */
function create (model, opt = {}) {
	let sizes = _.clone(STANDARD_SIZES)
	if (opt.extraLarge) {
		sizes = sizes.concat(EXTRA_LARGE_SIZES)
	}

	// #38864: If using relative sizes we put the smallest first
	if (opt.baseSize) {
		sizes = _.reverse(sizes)
	}

	let property = opt.property || 'fontSize'

	var fontSizeOptions = sizes.map(function (size) {
		const label = sizeLabel(size, opt.baseSize)
		let optionClass = FontSizeOption.extend({
			value: size, label, property, baseSize: opt.baseSize
		})
		if (opt.updateModel) {
			optionClass = optionClass.extend({ updateModel: opt.updateModel })
		}
		return {
			label: size + '',
			contentView: optionClass,
			model: model
		}
	})

	function getLabel () {
		if (opt.label) {
			return _.result(opt, 'label')
		} else {
			return opt.baseSize ? 'common.fontSize.adjustment' : 'common.fontSize'
		}
	}

	return {
		type: 'value-then-submenu',
		label: getLabel(),
		contentView: FontSizeLabelView.extend({
			property,
			label: getLabel,
			baseSize: opt.baseSize
		}),
		model,
		target: fontSizeOptions,
		hidden: opt.hidden
	}
}

// STANDARD_SIZES + EXTRA_LARGE_SIZES must be kept in sync with
// sass/variables/measurements.scss:$widget-font-sizes
const STANDARD_SIZES = [6, 7, 8, 9, 10, 11, 13, 14, 15, 16, 18, 20, 24, 26, 29, 32, 34, 37]

const EXTRA_LARGE_SIZES = [ 48, 72 ]

const ALL_SIZES = STANDARD_SIZES.concat(EXTRA_LARGE_SIZES)

export default create
export { ALL_SIZES }

create.__filename__ = 'dashboards/widgets/font-size-menu.js'
